import { Commit, ActionTree, MutationTree, Dispatch } from 'vuex';
import { State, Group } from '@/store/modules/apm/topoGroup/topoGroup.store';

const mutations: MutationTree<State> = {
  initGroups(state: State, data: any): void {
    if (data) {
      state.groups = data.groups;
    } else {
      state.groups = [];
    }
  },
  saveGroups(state: State): void {
    localStorage.setItem('topology-groups', JSON.stringify(state.groups));
  },

  deleteGroup(state: State, id: string): void {
    const index = state.groups.findIndex((i: Group) => i.id === id);
    if (index === -1) {
      return;
    }
    state.groups.splice(index, 1);
    state.groupId = state.groups.length === 0 ? 'all' : state.groups[0].id;
    if (state.groups.length) {
      const nextGroupId = state.groups[0].id;
      if (!nextGroupId) {
        state.groupId = 'all';
      }
      state.groupId = nextGroupId;
    }
    //state.groupId = 'all';
    localStorage.setItem('topology-groups', JSON.stringify(state.groups));
  },
  selectGroup(state: State, id: string): void {
    state.groupId = id;
    // localStorage.setItem('topology-group-history', id);
  },
  unSelectGroup(state: State): void {
    state.groupId = 'all';
    localStorage.removeItem('topology-group-history');
  },
  addGroupService(
    state: State,
    data: { groupIndex: any; service: { label: string; key: string } }
  ): void {
    const services = state.groups[data.groupIndex].apps;
    const index = services.findIndex(i => i.label === data.service.label);
    if (index === -1) {
      services.push(data.service);
    }
    localStorage.setItem('topology-groups', JSON.stringify(state.groups));
  },
  deleteGroupService(
    state: State,
    data: { groupIndex: any; service: { label: string; key: string } }
  ): void {
    const services = state.groups[data.groupIndex].apps;
    const index = services.findIndex(i => i.label === data.service.label);
    if (index !== -1) {
      services.splice(index, 1);
    }
    localStorage.setItem('topology-groups', JSON.stringify(state.groups));
  }
};

export default mutations;
